import { Helmet } from "react-helmet-async";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";

const Regulamin = () => (
  <div className="min-h-screen bg-background">
    <Helmet>
      <title>Regulamin serwisu | WystepKabaretu.pl</title>
      <meta name="description" content="Regulamin serwisu WystepKabaretu.pl - zasady korzystania z serwisu, formularz kontaktowy, prawa autorskie." />
      <link rel="canonical" href="https://wystepkabaretu.pl/regulamin" />
      <meta name="robots" content="index, follow" />
    </Helmet>
    <Navigation />
    <main className="container max-w-3xl py-16 px-4 pt-28">
      <h1 className="text-4xl font-montserrat font-black text-foreground mb-8">Regulamin serwisu</h1>

      <div className="prose prose-lg max-w-none text-muted-foreground space-y-6">
        <h2 className="text-xl font-bold text-foreground mt-8">§1. Postanowienia ogólne</h2>
        <p>1. Niniejszy regulamin określa zasady korzystania z serwisu internetowego WystepKabaretu.pl.</p>
        <p>2. Właścicielem serwisu jest Wirtualny Biznes z siedzibą przy ul. Księcia Witolda 49/15, 50-202 Wrocław, NIP: 8961619199.</p>
        <p>3. Korzystanie z serwisu oznacza akceptację niniejszego regulaminu.</p>

        <h2 className="text-xl font-bold text-foreground mt-8">§2. Definicje</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Serwis</strong> - strona internetowa dostępna pod adresem WystepKabaretu.pl</li>
          <li><strong>Użytkownik</strong> - osoba fizyczna korzystająca z Serwisu</li>
          <li><strong>Usługodawca</strong> - Wirtualny Biznes</li>
        </ul>

        <h2 className="text-xl font-bold text-foreground mt-8">§3. Zakres usług</h2>
        <p>1. Serwis umożliwia zapoznanie się z ofertą usług kabaretowych oraz przesyłanie zapytań za pośrednictwem formularza kontaktowego.</p>
        <p>2. Korzystanie z serwisu jest bezpłatne.</p>
        <p>3. Szczegółowe warunki świadczenia usług kabaretowych ustalane są indywidualnie z klientem.</p>

        <h2 className="text-xl font-bold text-foreground mt-8">§4. Formularz kontaktowy</h2>
        <p>1. Przesłanie formularza kontaktowego wymaga podania danych osobowych: imienia i nazwiska, adresu e-mail, numeru telefonu oraz treści wiadomości.</p>
        <p>2. Przesłanie formularza jest równoznaczne z wyrażeniem zgody na przetwarzanie danych osobowych w celu odpowiedzi na zapytanie.</p>

        <h2 className="text-xl font-bold text-foreground mt-8">§5. Prawa autorskie</h2>
        <p>1. Wszelkie treści zamieszczone w Serwisie, w tym teksty, grafiki, zdjęcia i materiały wideo, są chronione prawem autorskim.</p>
        <p>2. Kopiowanie, rozpowszechnianie lub wykorzystywanie materiałów z Serwisu bez pisemnej zgody Usługodawcy jest zabronione.</p>

        <h2 className="text-xl font-bold text-foreground mt-8">§6. Odpowiedzialność</h2>
        <p>1. Usługodawca dokłada wszelkich starań, aby informacje zamieszczone w Serwisie były aktualne i rzetelne.</p>
        <p>2. Usługodawca nie ponosi odpowiedzialności za przerwy w działaniu Serwisu wynikające z przyczyn technicznych.</p>

        <h2 className="text-xl font-bold text-foreground mt-8">§7. Postanowienia końcowe</h2>
        <p>1. Usługodawca zastrzega sobie prawo do zmiany niniejszego regulaminu.</p>
        <p>2. W sprawach nieuregulowanych niniejszym regulaminem zastosowanie mają przepisy prawa polskiego.</p>
        <p>3. Kontakt: <a href="mailto:kontakt@wystepkabaretu.pl" className="text-accent hover:underline">kontakt@wystepkabaretu.pl</a>.</p>
      </div>
    </main>
    <Footer />
  </div>
);

export default Regulamin;
